import { render, staticRenderFns } from "./MOrderDetail.vue?vue&type=template&id=08e9c086"
import script from "./MOrderDetail.vue?vue&type=script&lang=js"
export * from "./MOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports